import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useReducer, useMemo } from 'react';
import { SET_PROGRESS_NOTES, SET_ORDER_TYPES, SET_PATIENT_APPROVALS, SET_PATIENT_ORDERS, REFRESH_PN_GLOBAL_CONTEXT, SET_NOTES_READY, REFRESH_PN_DATA, RESET_REFRESH_PN_DATA, SET_NEXT_IDG_MEETING, SET_PATIENT_ON_AD_HOC_IDG_AGENDA, SET_IDG_FILTER, SET_REFETCH_ALL_PROGRESS_NOTES_PENDING } from './constants';
const params = new URLSearchParams(window.location.search);
const initialState = {
  progressNotesGlobal: null,
  orderTypesGlobal: null,
  patientApprovalsGlobal: null,
  refreshPNData: {
    count: 0,
    scroll: false
  },
  notesReady: false,
  patientOrdersGlobal: null,
  nextIDGMeeting: null,
  patientOnAdHocIDGAgenda: null,
  idgFilter: !!params.get('idgmeeting'),
  refetchAllProgressNotesPending: false,
  dispatchPN: null
};
const initPNGlobalContext = {
  progressNotesGlobal: null,
  orderTypesGlobal: null,
  patientApprovalsGlobal: null,
  refreshPNData: {
    count: 0,
    scroll: false
  },
  patientOrdersGlobal: null,
  nextIDGMeeting: null,
  patientOnAdHocIDGAgenda: null,
  notesReady: false,
  idgFilter: !!params.get('idgmeeting'),
  refetchAllProgressNotesPending: false,
  dispatchPN: null
};
export const PNGlobalContextReducer = (state, action) => {
  var _action$payload;

  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_PROGRESS_NOTES:
      newState.progressNotesGlobal = action.payload;
      break;

    case REFRESH_PN_GLOBAL_CONTEXT:
      newState.progressNotesGlobal = null;
      newState.patientApprovalsGlobal = null;
      break;

    case SET_ORDER_TYPES:
      newState.orderTypesGlobal = action.payload;
      break;

    case SET_PATIENT_APPROVALS:
      newState.patientApprovalsGlobal = action.payload;
      break;

    case REFRESH_PN_DATA:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        refreshPNData: {
          count: state.refreshPNData.count + 1,
          scroll: action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.scroll ? action.payload.scroll : false
        }
      });
      break;

    case RESET_REFRESH_PN_DATA:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        refreshPNData: {
          count: 0,
          scroll: false
        }
      });
      break;

    case SET_PATIENT_ORDERS:
      newState.patientOrdersGlobal = action.payload;
      break;

    case SET_NOTES_READY:
      newState.notesReady = action.payload;
      break;

    case SET_NEXT_IDG_MEETING:
      newState.nextIDGMeeting = action.payload;
      break;

    case SET_PATIENT_ON_AD_HOC_IDG_AGENDA:
      newState.patientOnAdHocIDGAgenda = action.payload;
      break;

    case SET_IDG_FILTER:
      newState.idgFilter = action.payload;
      break;

    case SET_REFETCH_ALL_PROGRESS_NOTES_PENDING:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        refetchAllProgressNotesPending: !!action.payload
      });
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const PNGlobalContext = /*#__PURE__*/createContext(initPNGlobalContext);
export const PNGlobalDispatchContext = /*#__PURE__*/createContext({});
export const PNGlobalContextConsumer = PNGlobalContext.Consumer;
export const PNGlobalDispatchContextConsumer = PNGlobalDispatchContext.Consumer;
export const PNGlobalContextProvider = ({
  children
}) => {
  const [{
    progressNotesGlobal,
    orderTypesGlobal,
    patientApprovalsGlobal,
    refreshPNData,
    patientOrdersGlobal,
    notesReady,
    nextIDGMeeting,
    patientOnAdHocIDGAgenda,
    idgFilter,
    refetchAllProgressNotesPending
  }, dispatch] = useReducer(PNGlobalContextReducer, initialState);
  const context = useMemo(() => ({
    progressNotesGlobal,
    orderTypesGlobal,
    patientApprovalsGlobal,
    patientOrdersGlobal,
    notesReady,
    nextIDGMeeting,
    patientOnAdHocIDGAgenda,
    idgFilter,
    refetchAllProgressNotesPending,
    dispatchPN: dispatch,
    refreshPNData
  }), [progressNotesGlobal, orderTypesGlobal, patientApprovalsGlobal, refreshPNData, patientOrdersGlobal, nextIDGMeeting, patientOnAdHocIDGAgenda, idgFilter, refetchAllProgressNotesPending, notesReady, dispatch]);
  return /*#__PURE__*/React.createElement(PNGlobalContext.Provider, {
    value: context
  }, children);
};
export function withPNGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(PNGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(PNGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default PNGlobalContext;